import { observable, action, toJS, computed, makeObservable, runInAction } from 'mobx'
import api from '../service/api'
// import UserStore from "./user.store"
// import fileDownload from 'js-file-download'
import React from 'react'

class OnlineSessionsStore {

    selectedSessionDetails
    lastSelectedSession
    onlineSessions
    loadingStatus
    errors

    constructor () {

        this.selectedSessionDetails = {
            classAccessTimeExtensionRequests: [],
            sessionMetadata: {},
            polls: [],
            feedbacks: [],
            recordings: [],
            quizInstance: {},
            attendance: {
                creatorAttendance: {},

                quizParticipationAttendance: [],
                videosWatchAttendance: [],
                streamAttendance: [],
            },
        }
        this.errors = {
            accessTimeExtensionsRequests: null,
            onlineSessionAttendance: null,
            onlineSessionRecordings: null,
            onlineSessionFeedbacks: null,
            onlineSessionPolls: null,
            onlineSessions: null,
            onlineSession: null,
        }
        this.onlineSessions = []

        this.loadingStatus = {
            accessTimeExtensionsRequests: { refreshing: false, initialLoad: true },
            onlineSessionPollsAndChats: { refreshing: false, initialLoad: true },
            onlineSessionAttendance: { refreshing: false, initialLoad: true },
            onlineSessionRecordings: { refreshing: false, initialLoad: true },
            onlineSessionFeedbacks: { refreshing: false, initialLoad: true },
            onlineSessionMetadata: { refreshing: false, initialLoad: true },
            onlineSessionPolls: { refreshing: false, initialLoad: true },
            onlineSessions: { refreshing: false, initialLoad: true },
        }
        this.lastSelectedSession = null

        makeObservable( this, {
            selectedSessionDetails: observable,
            onlineSessions: observable,
            loadingStatus: observable,
            errors: observable,

            fetchHybridClassAccessTimeExtensionRequests: action,
            fetchOnlineSessionAttendance: action,
            fetchOnlineSessionRecordings: action,
            fetchOnlineSessionFeedbacks: action,
            fetchOnlineSessionMetadata: action,
            fetchOnlineSessionDetails: action,
            fetchOnlineSessionPolls: action,
            fetchOnlineSessions: action,


            // --- Loading Status Getters ---
            getHybridClassAccessTimeExtensionRequestsLoadingStatus: computed,
            getRecordingsLoadingStatus: computed,
            getAttendanceLoadingStatus: computed,
            getFeedbacksLoadingStatus: computed,
            getSessionsLoadingStatus: computed,
            getMetadataLoadingStatus: computed,
            getPollsLoadingStatus: computed,

            // --- Sessions ---
            getQuizParticipationAttendance: computed,
            getAccessTimeExtentionRequests: computed,
            getOnlineSessionQuizInstance: computed,
            getVideosWatchAttendance: computed,
            getStreamAttendance: computed,
            getPresentUsersList: computed,
            getStreamRecordings: computed,
            getSessionMetadata: computed,
            getOnlineSessions: computed,
            getFeedbacks: computed,
            getPolls: computed,
            getErrors: computed,
        } )
    }

    resetForNewSessionData () {
        this.selectedSessionDetails = {
            sessionMetadata: {},
            polls: [],
            feedbacks: [],
            attendance: {
                creatorAttendance: {},

                quizParticipationAttendance: [],
                videosWatchAttendance: [],
                streamAttendance: [],
            },
        }
        this.errors = {
            onlineSessionAttendance: null,
            onlineSessionRecordings: null,
            onlineSessionFeedbacks: null,
            onlineSessions: null,
            onlineSession: null,
        }
    }

    async fetchOnlineSessions () {
        try {

            runInAction( () => {
                this.loadingStatus.onlineSessions.refreshing = true
                this.loadingStatus.onlineSessions.initialLoad = this.onlineSessions.length === 0
            } )

            const { data: { data: sessions } } = await api.onlineMeetings.fetchMeetings()

            runInAction( () => {
                this.onlineSessions = sessions
                this.errors.onlineSessions = null
            } )

        } catch ( err ) {
            console.log( err )
            runInAction( () => {
                this.errors.onlineSessions = { code: err?.response?.status, message: err?.response?.data?.message || "Something went wrong! failed to fetch your meetings." }
            } )
        } finally {
            runInAction( () => {
                this.loadingStatus.onlineSessions.initialLoad = false
                this.loadingStatus.onlineSessions.refreshing = false
            } )
        }
    }

    async fetchOnlineSessionDetails ( meetingId ) {
        try {
            const { data: { data: meeting } } = await api.onlineMeetings.fetchMeeting( meetingId )
            this.selectedSessionDetails.sessionMetadata = meeting
            this.errors.onlineSession = null
            return true
        } catch ( err ) {
            console.log( err )
            this.errors.onlineSession = { message: err?.response?.data?.message || "Failed to fetch meeting details!", code: err?.response?.status }
            return false
        }
    }

    async fetchOnlineSessionMetadata ( meetingId ) {
        try {

            runInAction( () => {
                this.loadingStatus.onlineSessionMetadata.initialLoad = meetingId !== this.lastSelectedSession
                this.loadingStatus.onlineSessionMetadata.refreshing = true
                this.lastSelectedSession = meetingId
                if ( meetingId !== this.lastSelectedSession ) {
                    this.resetForNewSessionData()
                }
            } )

            const { data: { data: meeting } } = await api.onlineMeetings.fetchMeeting( meetingId )
            runInAction( () => {
                this.selectedSessionDetails.sessionMetadata = meeting
                this.errors.onlineSession = null
            } )
            return true
        } catch ( err ) {
            console.log( err )
            runInAction( () => {
                this.errors.onlineSession = { message: err?.response?.data?.message || "Failed to fetch meeting details!", code: err?.response?.status }
            } )
            return false
        } finally {
            runInAction( () => {
                this.loadingStatus.onlineSessionMetadata.initialLoad = false
                this.loadingStatus.onlineSessionMetadata.refreshing = false
            } )
        }
    }

    async fetchOnlineSessionFeedbacks ( meetingId ) {
        const loader = this.loadingStatus.onlineSessionFeedbacks

        runInAction( () => {
            loader.refreshing = true
        } )

        try {
            const { data: { data: feedbacks } } = await api.onlineMeetings.fetchMeetingFeedbacks( meetingId )
            runInAction( () => {
                // Store raw data for the component to use in useMemo
                this.selectedSessionDetails.feedbacks = feedbacks
                this.errors.onlineSessionFeedbacks = null
            } )
        } catch ( err ) {
            console.error( err )
            runInAction( () => {
                this.errors.onlineSessionFeedbacks = { message: err?.response?.data?.message || "Failed to fetch meeting recordings!", code: err?.response?.status }
            } )
        } finally {
            runInAction( () => {
                loader.refreshing = false
                loader.initialLoad = false
            } )
        }
    }

    async fetchOnlineSessionPolls ( meetingId ) {
        const loader = this.loadingStatus.onlineSessionAttendance

        runInAction( () => {
            loader.refreshing = true
            loader.initialLoad = meetingId !== this.lastSelectedSession
        } )
        try {
            const { data: { data: { polls, pollVotes } } } = await api.onlineMeetings.fetchMeetingChatsAndPoll( meetingId )

            const pollsList = []
            const pollsAndVotesMap = {}
            for ( const vote of pollVotes ) {
                const voteDetails = {
                    user_id: vote.voter_id,
                    name: vote.voter_data.name,
                    poll_vote: vote.poll_vote
                }
                if ( pollsAndVotesMap[vote.poll_id] ) {
                    pollsAndVotesMap[vote.poll_id].push( voteDetails )
                } else {
                    pollsAndVotesMap[vote.poll_id] = [voteDetails]
                }
            }

            for ( const poll of polls ) {
                poll.votes = Array.from( { length: poll?.options?.length }, () => [] )
                for ( const pollVoteDetails of pollsAndVotesMap[poll.id] || [] ) {
                    poll.votes[+( pollVoteDetails.poll_vote )].push( pollVoteDetails )
                }
                poll.totalVotes = ( pollsAndVotesMap[poll.id] || [] ).length
                pollsList.push( poll )

            }

            runInAction( () => {
                this.selectedSessionDetails.polls = pollsList
                this.errors.onlineSessionPolls = null
            } )
        } catch ( err ) {
            console.error( err )
            runInAction( () => {
                this.errors.onlineSessionPolls = { message: err?.response?.data?.message || "Failed to fetch session polls!", code: err?.response?.status }
            } )
        } finally {
            runInAction( () => {
                loader.refreshing = false
                loader.initialLoad = false
            } )
        }
    }

    async fetchHybridClassAccessTimeExtensionRequests ( meetingId ) {
        const loader = this.loadingStatus.accessTimeExtensionsRequests

        runInAction( () => {
            loader.refreshing = true
            loader.initialLoad = meetingId !== this.lastSelectedSession
        } )

        try {
            const { data: { data: requests } } = await api.onlineMeetings.fetchHybridClassAccessTimeExtensionRequests( meetingId )
            runInAction( () => {
                // Store raw data for the component to use in useMemo
                this.selectedSessionDetails.classAccessTimeExtensionRequests = requests
                this.errors.accessTimeExtensionsRequests = null
            } )
        } catch ( err ) {
            console.error( err )
            runInAction( () => {
                this.errors.accessTimeExtensionsRequests = { message: err?.response?.data?.message || "Failed to fetch meeting recordings!", code: err?.response?.status }
            } )
        } finally {
            runInAction( () => {
                loader.refreshing = false
                loader.initialLoad = false
            } )
        }
    }

    async fetchOnlineSessionAttendance ( meetingId ) {
        const loader = this.loadingStatus.onlineSessionAttendance

        runInAction( () => {
            loader.refreshing = true
        } )

        try {
            const { data: { data } } = await api.onlineMeetings.fetchMeetingAttendance( meetingId )

            const videoAttendance = ( data.videoViewers || [] )
            videoAttendance.forEach( user => user.present = user.average > ( data.thresholds?.watchProgressAttendanceThreshold || 80 ) )

            runInAction( () => {
                // Store raw data for the component to use in useMemo
                this.selectedSessionDetails.attendance.streamAttendance = data.attendanceRecords || []
                this.selectedSessionDetails.attendance.videosWatchAttendance = videoAttendance
                this.selectedSessionDetails.attendance.quizParticipationAttendance = data.quiz?.students || []
                this.selectedSessionDetails.quizInstance = data.quiz || []

                // Store metadata for boundary logic
                this.selectedSessionDetails.attendance.creatorAttendance = data.creatorAttendance
                this.errors.onlineSessionAttendance = null
            } )
        } catch ( err ) {
            console.error( err )
            runInAction( () => {
                this.errors.onlineSessionAttendance = { message: err?.response?.data?.message || "Failed to fetch meeting attendance!", code: err?.response?.status }
            } )
        } finally {
            runInAction( () => {
                loader.refreshing = false
                loader.initialLoad = false
            } )
        }
    }

    async fetchOnlineSessionRecordings ( meetingId ) {
        const loader = this.loadingStatus.onlineSessionRecordings

        if ( loader.refreshing ) return

        runInAction( () => {
            loader.refreshing = true
        } )

        try {
            const { data: { data } } = await api.recording.fetchMeetingRecordings( meetingId )
            data.recordings.forEach( item => item.type = "recording" )
            data.class_videos.forEach( item => item.type = "upload-video" )
            const allVideos = [...data.recordings, ...data.class_videos]

            runInAction( () => {
                // Store raw data for the component to use in useMemo
                this.selectedSessionDetails.recordings = allVideos
                this.errors.onlineSessionRecordings = null
            } )
        } catch ( err ) {
            console.error( err )
            runInAction( () => {
                this.errors.onlineSessionRecordings = { message: err?.response?.data?.message || "Failed to fetch meeting recordings!", code: err?.response?.status }
            } )
        } finally {
            runInAction( () => {
                loader.refreshing = false
                loader.initialLoad = false
            } )
        }
    }

    // --- Sessions ---
    get getOnlineSessions () {
        return toJS( this.onlineSessions )
    }

    // --- Formal Metadata Getter ---
    get getSessionMetadata () {
        return toJS( this.selectedSessionDetails.sessionMetadata )
    }

    // --- List Getters ---
    get getPolls () {
        return toJS( this.selectedSessionDetails.polls )
    }

    get getFeedbacks () {
        return toJS( this.selectedSessionDetails.feedbacks )
    }

    // --- Attendance Getters ---
    get getStreamAttendance () {
        return toJS( this.selectedSessionDetails.attendance.streamAttendance )
    }

    get getStreamRecordings () {
        return toJS( this.selectedSessionDetails.recordings )
    }

    get getAccessTimeExtentionRequests () {
        return toJS( this.selectedSessionDetails.classAccessTimeExtensionRequests )
    }

    get getCreatorAttendance () {
        return toJS( this.selectedSessionDetails.attendance.creatorAttendance )
    }

    get getOnlineSessionQuizInstance () {
        return toJS( this.selectedSessionDetails.quizInstance )
    }

    get getVideosWatchAttendance () {
        return toJS( this.selectedSessionDetails.attendance.videosWatchAttendance )
    }

    get getPresentUsersList () {

        const calculatedAttendance = [...this.selectedSessionDetails.attendance.streamAttendance]
        const creatorAttendanceData = this.selectedSessionDetails.attendance.creatorAttendance
        const threshold = 50

        // Helper

        const mergeSessions = ( sessions ) => {
            if ( !sessions?.length ) return []

            const sorted = [...sessions].sort( ( a, b ) => new Date( a.joined_at ) - new Date( b.joined_at ) )
            const merged = []
            let current = { ...sorted[0] }

            for ( let i = 1; i < sorted.length; i++ ) {
                const next = sorted[i]

                const currentEnd = new Date( current.left_at )
                const nextStart = new Date( next.joined_at )

                if ( nextStart <= currentEnd ) {
                    // merge if overlapping or touching
                    const nextEnd = new Date( next.left_at )
                    current.left_at = nextEnd > currentEnd ? next.left_at : current.left_at
                    current.duration = new Date( current.left_at ) - new Date( current.joined_at )
                } else {
                    merged.push( current )
                    current = { ...next }
                }
            }

            merged.push( current )
            return merged
        }

        const creatorSessions = mergeSessions( [...( creatorAttendanceData?.sessions || [] )].filter( ( { left_at, joined_at } ) => new Date( left_at ) > new Date( creatorAttendanceData?.meetingTime?.starts_at ) && new Date( joined_at ) < new Date( creatorAttendanceData?.meetingTime?.ends_at ) ) )

        // host's session boundaries
        let earliestSession = creatorSessions?.[0] || { joined_at: creatorAttendanceData?.meetingTime?.starts_at, left_at: creatorAttendanceData?.meetingTime?.ends_at }
        let latestSession = creatorSessions?.[creatorSessions.length - 1] || { joined_at: creatorAttendanceData?.meetingTime?.starts_at, left_at: creatorAttendanceData?.meetingTime?.ends_at }

        latestSession.left_at = new Date( Math.min( new Date( creatorAttendanceData?.meetingTime?.ends_at ), new Date( latestSession?.left_at ) ) )
        earliestSession.joined_at = new Date( Math.max( new Date( creatorAttendanceData?.meetingTime?.starts_at ), new Date( earliestSession?.joined_at ) ) )

        if ( earliestSession ) {
            earliestSession.joined_at = new Date( earliestSession.joined_at )
            earliestSession.left_at = new Date( earliestSession.left_at )
        }
        if ( latestSession ) {
            latestSession.joined_at = new Date( latestSession.joined_at )
            latestSession.left_at = new Date( latestSession.left_at )
        }


        // decide totalDuration
        let totalDuration = latestSession.left_at - earliestSession.joined_at
        if ( creatorSessions && creatorSessions.length > 0 )
            totalDuration = creatorSessions.reduce(
                ( acc, { duration } ) => acc + ( duration ),
                0
            )

        totalDuration = totalDuration || 10

        for ( const attendanceDetails of calculatedAttendance ) {
            let adjustedTotalTime = attendanceDetails.total_time

            if ( earliestSession && latestSession ) {

                // apply boundary trimming only if hostsDuration = true
                const adjustedSessions = []
                for ( const [idx, session] of mergeSessions( attendanceDetails.sessions || [] )?.entries() ) {
                    let { joined_at, left_at } = session
                    joined_at = new Date( joined_at )
                    left_at = new Date( left_at )

                    if ( left_at <= earliestSession.joined_at || joined_at >= latestSession.left_at ) {
                        continue
                    }
                    // Trim first session if before host's first joined_at
                    if ( idx === 0 && joined_at < earliestSession.joined_at ) {
                        joined_at = earliestSession.joined_at
                    }

                    // Trim last session if after host's last left_at
                    if ( idx === attendanceDetails.sessions.length - 1 && left_at > new Date( latestSession.left_at ) ) {
                        left_at = new Date( latestSession.left_at )
                    }

                    adjustedSessions.push( { joined_at, left_at } )
                }

                adjustedTotalTime = adjustedSessions.reduce(
                    ( acc, { joined_at, left_at } ) => acc + ( left_at - joined_at ),
                    0
                )
            }

            attendanceDetails.total_time = adjustedTotalTime

            attendanceDetails.present = adjustedTotalTime >= ( totalDuration * ( threshold / 100 ) )
            attendanceDetails.present_percentage = Math.min(
                Math.round( ( adjustedTotalTime * 100 ) / totalDuration ),
                100
            )
            // console.log( attendanceDetails )

            attendanceDetails.threshold_percent = threshold
            attendanceDetails.threshold_in_ms = totalDuration * ( threshold / 100 )
        }

        const onlineSessionUsers = calculatedAttendance.filter( u => u.present_percentage > 50 ).map( u => u.user_id )
        const videoWatchUsers = this.selectedSessionDetails.attendance.videosWatchAttendance.filter( v => v.average > 50 ).map( v => v.user_id )
        return toJS( Array.from( new Set( [...onlineSessionUsers, ...videoWatchUsers] ) ) )
    }

    get getQuizParticipationAttendance () {
        return toJS( this.selectedSessionDetails.attendance.quizParticipationAttendance )
    }

    // --- Loading Status Getters ---

    get getHybridClassAccessTimeExtensionRequestsLoadingStatus () {
        return toJS( this.loadingStatus.accessTimeExtensionsRequests )
    }

    get getSessionsLoadingStatus () {
        return toJS( this.loadingStatus.onlineSessions )
    }

    get getMetadataLoadingStatus () {
        return toJS( this.loadingStatus.onlineSessionMetadata )
    }

    get getAttendanceLoadingStatus () {
        return toJS( this.loadingStatus.onlineSessionAttendance )
    }

    get getPollsLoadingStatus () {
        return toJS( this.loadingStatus.onlineSessionPolls )
    }

    get getFeedbacksLoadingStatus () {
        return toJS( this.loadingStatus.onlineSessionFeedbacks )
    }

    get getRecordingsLoadingStatus () {
        return toJS( this.loadingStatus.onlineSessionRecordings )
    }

    // --- Errors ---
    get getErrors () {
        return toJS( this.errors )
    }

}

const OnlineSessionsStoreInstance = new OnlineSessionsStore()

export default OnlineSessionsStoreInstance

const OnlineSessionsStoreContext = React.createContext()

export const OnlineSessionsStoreProvider = ( { children, store } ) => {
    return (
        <OnlineSessionsStoreContext.Provider value={store}>{children}</OnlineSessionsStoreContext.Provider>
    )
}

/* Hook to use store in any functional component */
export const useOnlineSessionsStore = () => React.useContext( OnlineSessionsStoreContext )